import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import {
  openAccionConfirmToggle,
  openAccionFormModal,
  openAccionViewModal,
} from "../../store/reducers/fortalezas/fortalezas.reducer";
import { getAccionDesarrolloByIdThunk } from "../../store/reducers/fortalezas/fortalezas.thunks";

const AccionActions = ({ accion }) => {
  const dispatch = useDispatch();

  const handleEdit = async () => {
    await dispatch(getAccionDesarrolloByIdThunk(accion.id));
    dispatch(
      openAccionFormModal({
        mode: "edit",
      })
    );
  };

  const handleToggle = () => {
    dispatch(
      openAccionConfirmToggle({
        id: accion.id,
      })
    );
  };

  const handleView = () => {
    dispatch(openAccionViewModal());
    dispatch(getAccionDesarrolloByIdThunk(accion.id));
  };

  const itemClass =
    "dropdown-item px-16 py-8 rounded d-flex align-items-center gap-2 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900";

  return (
    <div className="dropdown text-center">
      <button
        type="button"
        className="btn btn-sm"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Icon
          icon="ph:dots-three-outline-vertical-fill"
          width="20"
          className="text-neutral-700"
        />
      </button>

      <ul className="dropdown-menu p-12 border bg-base shadow">
        <li>
          <button className={itemClass} onClick={handleView}>
            <Icon icon="mdi:eye-outline" width="18" />
            <span>Ver</span>
          </button>
        </li>

        <li>
          <button className={itemClass} onClick={handleEdit}>
            <Icon icon="mdi:pencil-outline" width="18" />
            <span>Editar</span>
          </button>
        </li>

        <li>
          <button
            className={`${itemClass} ${accion.is_active ? "text-danger" : "text-success"}`}
            onClick={handleToggle}
          >
            <Icon
              icon={
                accion.is_active
                  ? "mdi:toggle-switch-off-outline"
                  : "mdi:toggle-switch-outline"
              }
              width="18"
            />
            <span>{accion.is_active ? "Desactivar" : "Activar"}</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default AccionActions;
